import React, { useState } from 'react';
import "../Services.css";
import DeskImage from "../../Assets/Images/USA.jpg";
import FAQSection from "./UsaFAQs.js";
import ContactForm from "../../ContactForm/ContactFormModal.js";

const App = () => {
  const [showContactForm, setShowContactForm] = useState(false);
  return (
    <section id="services" className="service-page">
      <div className="container">
        <div className="service-hero">
          <div className="hero-text">
            <h1>Start Smart: Seamless USA Company Formation for Global Entrepreneurs</h1>
            <p className="hero-subtitle">Form your LLC or C-Corp in the USA effortlessly. BooksComply handles your state filing, EIN registration, Registered Agent setup, and banking guidance — everything needed to launch your U.S. business from anywhere in the world.</p>
            <div className="hero-buttons" style={{ display: 'flex', gap: '16px', marginTop: '28px', flexWrap: 'wrap' }}>
              <a
                href="/pricing"
                className="btn-primary" 
                style={{
                  backgroundColor: '#2D1FF4',
                  color: 'white',
                  padding: '12px 28px',
                  borderRadius: '8px',
                  fontWeight: '600',
                  textDecoration: 'none',
                  transition: 'all 0.2s ease',
                  display: 'inline-block',
                  textAlign: 'center',
                  border: 'none',
                  cursor: 'pointer',
                  fontSize: '1rem',
                  boxShadow: '0 2px 4px rgba(45, 31, 244, 0.2)'
                }}
                onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#1E16B0'}
                onMouseOut={(e) => e.currentTarget.style.backgroundColor = '#2D1FF4'}
              >
                See Plans
              </a>
              <button
                onClick={(e) => {
                  e.preventDefault();
                  setShowContactForm(true);
                }}
                className="btn-outline" 
                style={{
                  backgroundColor: 'transparent',
                  color: '#2D1FF4',
                  padding: '12px 28px',
                  borderRadius: '8px',
                  fontWeight: '600',
                  textDecoration: 'none',
                  transition: 'all 0.2s ease',
                  display: 'inline-block',
                  textAlign: 'center',
                  border: '2px solid #2D1FF4',
                  cursor: 'pointer',
                  fontSize: '1rem'
                }}
                onMouseOver={(e) => {
                  e.currentTarget.style.backgroundColor = '#F0EFFF';
                  e.currentTarget.style.borderColor = '#1E16B0';
                  e.currentTarget.style.color = '#1E16B0';
                }}
                onMouseOut={(e) => {
                  e.currentTarget.style.backgroundColor = 'transparent';
                  e.currentTarget.style.borderColor = '#2D1FF4';
                  e.currentTarget.style.color = '#2D1FF4';
                }}
              >
                Book a Free Consultation
              </button>
            </div>
          </div>
          <div className="hero-media">
            <img src={DeskImage} alt="USA Company Formation" className="desk-image" />
          </div>
        </div>
      </div>
      
      {/* Our Complete USA Company Setup Services Section */}
      <section className="usa-services-section" style={{
        padding: '100px 0',
        background: 'linear-gradient(180deg, #f8fbff 0%, #f0f7ff 100%)',
        position: 'relative',
        overflow: 'hidden'
      }}>
        <div className="container">
          <div style={{
            textAlign: 'center',
            marginBottom: '60px',
            position: 'relative',
            zIndex: '1'
          }}>
            <h2 style={{
              fontSize: '2.5rem',
              fontWeight: '800',
              color: '#0f172a',
              margin: '0 0 20px',
              lineHeight: '1.2',
              position: 'relative',
              display: 'inline-block'
            }}>
              Our Complete USA Company Setup Services
              <span style={{
                position: 'absolute',
                bottom: '-10px',
                left: '0',
                width: '60px',
                height: '4px',
                background: '#2D1FF4',
                borderRadius: '2px',
                left: '50%',
                transform: 'translateX(-50%)'
              }}></span>
            </h2>
            <p style={{
              color: '#64748b',
              fontSize: '1.1rem',
              maxWidth: '700px',
              margin: '20px auto 0',
              lineHeight: '1.6'
            }}>
              Comprehensive solutions to establish and grow your US business presence
            </p>
          </div>
          
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(1, 1fr)',
            gap: '24px',
            maxWidth: '1400px',
            margin: '0 auto',
            padding: '0 16px',
            position: 'relative',
            zIndex: '1',
            '@media (min-width: 768px)': {
              gridTemplateColumns: 'repeat(2, 1fr)',
              gap: '30px',
              padding: '0 24px'
            },
            '@media (min-width: 1024px)': {
              gridTemplateColumns: 'repeat(4, 1fr)',
              padding: '0 20px'
            }
          }}>
            {/* Background pattern */}
            <div style={{
              position: 'absolute',
              top: '0',
              left: '0',
              width: '100%',
              height: '100%',
              backgroundImage: 'radial-gradient(rgba(45, 31, 244, 0.08) 1px, transparent 1px)',
              backgroundSize: '20px 20px',
              opacity: '0.6',
              zIndex: '-1'
            }}></div>
            
            {[
              {
                title: 'US Company Formation (LLC or C-Corp)',
                description: 'Form your U.S. company with full compliance — from selecting your state to filing formation documents and registering your EIN.',
                icon: '🏢'
              },
              {
                title: 'Registered Agent Service',
                description: 'Every U.S. business must appoint a registered agent. BooksComply offers 50-state coverage for reliable document handling and compliance alerts.',
                icon: '📋'
              },
              {
                title: 'EIN Registration (Tax ID)',
                description: 'Get your EIN from the IRS quickly — essential for opening a bank account, hiring staff, and paying taxes.',
                icon: '🔢'
              },
              {
                title: 'Banking Guidance for Global Founders',
                description: 'We guide you through opening a U.S. business bank account remotely, with full documentation and compliance support.',
                icon: '🏦'
              }
            ].map((service, index) => (
              <div key={index} style={{
                background: 'white',
                borderRadius: '16px',
                padding: '40px 30px',
                boxShadow: '0 4px 20px rgba(0, 0, 0, 0.04)',
                transition: 'all 0.4s cubic-bezier(0.16, 1, 0.3, 1)',
                border: '1px solid rgba(0, 0, 0, 0.04)',
                position: 'relative',
                overflow: 'hidden'
              }} onMouseOver={(e) => {
                e.currentTarget.style.transform = 'translateY(-8px)';
                e.currentTarget.style.boxShadow = '0 20px 40px rgba(45, 31, 244, 0.12)';
                e.currentTarget.style.borderColor = 'rgba(45, 31, 244, 0.15)';
              }} onMouseOut={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 4px 20px rgba(0, 0, 0, 0.04)';
                e.currentTarget.style.borderColor = 'rgba(0, 0, 0, 0.04)';
              }}>
                <div style={{
                  position: 'absolute',
                  top: '0',
                  left: '0',
                  width: '100%',
                  height: '4px',
                  background: 'linear-gradient(90deg, #2D1FF4 0%, #6D63FF 100%)',
                  opacity: '0.9'
                }}></div>
                <div style={{
                  width: '56px',
                  height: '56px',
                  borderRadius: '14px',
                  background: 'rgba(45, 31, 244, 0.1)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  marginBottom: '20px',
                  '@media (min-width: 768px)': {
                    width: '60px',
                    height: '60px',
                    borderRadius: '16px',
                    marginBottom: '24px'
                  }
                }}>
                  <div style={{
                    width: '40px',
                    height: '40px',
                    borderRadius: '12px',
                    background: '#2D1FF4',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    color: 'white',
                    fontSize: '20px',
                    fontWeight: 'bold'
                  }}>
                    {service.icon}
                  </div>
                </div>
                <h3 style={{
                  fontSize: '1.3rem',
                  color: '#0f172a',
                  margin: '0 0 14px',
                  fontWeight: '700',
                  lineHeight: '1.4',
                  position: 'relative',
                  paddingBottom: '10px',
                  '@media (min-width: 768px)': {
                    fontSize: '1.4rem',
                    margin: '0 0 16px',
                    paddingBottom: '12px'
                  }
                }}>
                  {service.title}
                </h3>
                <p style={{
                  color: '#64748b',
                  lineHeight: '1.6',
                  margin: '0',
                  fontSize: '1rem',
                  position: 'relative',
                  zIndex: '1',
                  '@media (min-width: 768px)': {
                    lineHeight: '1.7',
                    fontSize: '1.05rem'
                  }
                }}>
                  {service.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>
      
      {/* Why Start a Company in the USA Section */}
      <section className="why-usa-section" style={{
        padding: '80px 0',
        backgroundColor: '#f8f9ff',
        overflow: 'hidden'
      }}>
        <div className="container" style={{
          maxWidth: '1200px',
          margin: '0 auto',
          padding: '0 20px',
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          gap: '60px',
          '@media (max-width: 992px)': {
            flexDirection: 'column',
            textAlign: 'center',
            gap: '40px'
          }
        }}>
          {/* Left Side - Image */}
          <div style={{
            flex: '1',
            minWidth: '45%',
            borderRadius: '12px',
            overflow: 'hidden',
            boxShadow: '0 15px 30px rgba(0, 0, 0, 0.1)',
            '@media (max-width: 992px)': {
              width: '100%',
              maxWidth: '600px',
              margin: '0 auto'
            }
          }}>
            <img 
              src="https://images.unsplash.com/photo-1535016120720-40c646be5580?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1470&q=80" 
              alt="Business growth in the USA" 
              style={{
                width: '100%',
                height: 'auto',
                display: 'block',
                transition: 'transform 0.5s ease',
                ':hover': {
                  transform: 'scale(1.03)'
                }
              }}
            />
          </div>
          
          {/* Right Side - Content */}
          <div style={{
            flex: '1',
            padding: '20px 0',
            '@media (max-width: 992px)': {
              textAlign: 'center',
              padding: '0 10px'
            }
          }}>
            <h2 style={{
              fontSize: '2.2rem',
              color: '#0f172a',
              marginBottom: '25px',
              lineHeight: '1.3',
              fontWeight: '700',
              '@media (max-width: 768px)': {
                fontSize: '1.8rem'
              }
            }}>
              Why Start a Company in the USA?
            </h2>
            <p style={{
              fontSize: '1.1rem',
              color: '#4b5563',
              lineHeight: '1.8',
              marginBottom: '10px',
              '@media (max-width: 768px)': {
                fontSize: '1rem'
              }
            }}>
              Starting a business in the USA gives you access to one of the world's largest markets, strong investor networks, and business-friendly laws. Whether you're a tech founder or service provider, forming an LLC or C-Corp ensures credibility and global scalability.
            </p>
          </div>
        </div>
      </section>

      {/* Track Your Company Formation Progress Section */}
      <section style={{
        padding: '80px 0',
        backgroundColor: '#ffffff',
        overflow: 'hidden'
      }}>
        <div className="container" style={{
          maxWidth: '1200px',
          margin: '0 auto',
          padding: '0 20px',
          display: 'flex',
          flexDirection: 'row-reverse',
          alignItems: 'center',
          gap: '60px',
          '@media (max-width: 992px)': {
            flexDirection: 'column',
            textAlign: 'center',
            gap: '40px'
          }
        }}>
          {/* Right Side - Image */}
          <div style={{
            flex: '1',
            minWidth: '45%',
            borderRadius: '12px',
            overflow: 'hidden',
            boxShadow: '0 15px 30px rgba(0, 0, 0, 0.1)',
            '@media (max-width: 992px)': {
              width: '100%',
              maxWidth: '600px',
              margin: '0 auto'
            }
          }}>
            <img 
              src="https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1470&q=80" 
              alt="Project tracking dashboard" 
              style={{
                width: '100%',
                height: 'auto',
                display: 'block',
                transition: 'transform 0.5s ease',
                ':hover': {
                  transform: 'scale(1.03)'
                }
              }}
            />
          </div>
          
          {/* Left Side - Content */}
          <div style={{
            flex: '1',
            padding: '20px 0',
            '@media (max-width: 992px)': {
              textAlign: 'center',
              padding: '0 10px'
            }
          }}>
            <h2 style={{
              fontSize: '2.2rem',
              color: '#0f172a',
              marginBottom: '25px',
              lineHeight: '1.3',
              fontWeight: '700',
              '@media (max-width: 768px)': {
                fontSize: '1.8rem'
              }
            }}>
              Track Your Project in Real Time
            </h2>
            
            <div style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
              gap: '20px',
              marginBottom: '40px',
              textAlign: 'left',
              '@media (max-width: 768px)': {
                gridTemplateColumns: '1fr',
                textAlign: 'center'
              }
            }}>
              {[
                {
                  icon: '✅',
                  text: 'Monitor registration status and filings in real time.'
                },
                {
                  icon: '📄',
                  text: 'View uploaded documents and EIN progress.'
                },
                {
                  icon: '🔔',
                  text: 'Receive automated updates and compliance reminders.'
                },
                {
                  icon: '💬',
                  text: 'Chat directly with your assigned account manager.'
                }
              ].map((item, index) => (
                <div key={index} style={{
                  display: 'flex',
                  alignItems: 'flex-start',
                  gap: '12px',
                  padding: '15px',
                  backgroundColor: '#f8f9ff',
                  borderRadius: '8px',
                  transition: 'all 0.3s ease',
                  '@media (max-width: 768px)': {
                    justifyContent: 'center',
                    textAlign: 'center',
                    flexDirection: 'column',
                    alignItems: 'center'
                  },
                  ':hover': {
                    transform: 'translateY(-3px)',
                    boxShadow: '0 8px 20px rgba(0, 0, 0, 0.05)'
                  }
                }}>
                  <span style={{ 
                    fontSize: '24px',
                    flexShrink: 0,
                    '@media (max-width: 768px)': {
                      marginBottom: '8px'
                    }
                  }}>{item.icon}</span>
                  <p style={{
                    margin: 0,
                    fontSize: '1rem',
                    color: '#4b5563',
                    lineHeight: '1.6'
                  }}>{item.text}</p>
                </div>
              ))}
            </div>

            <button 
              onClick={() => {
                window.location.href = `${process.env.REACT_APP_REDIRECT_URL}/login`;
              }}
              style={{
                display: 'inline-block',
                backgroundColor: '#2D1FF4',
                color: 'white',
                padding: '12px 30px',
                borderRadius: '8px',
                border: 'none',
                cursor: 'pointer',
                fontWeight: '600',
                fontSize: '1rem',
                transition: 'all 0.3s ease',
                ':hover': {
                  backgroundColor: '#1e16b3',
                  transform: 'translateY(-2px)',
                  boxShadow: '0 5px 15px rgba(45, 31, 244, 0.3)'
                }
              }}
            >
              Log in to Your Dashboard →
            </button>
          </div>
        </div>
      </section>

      {/* Two-Column Section */}
      <section style={{ 
        padding: '60px 0', 
        backgroundColor: '#ffffff',
        background: 'linear-gradient(135deg, #f8faff 0%, #f0f4ff 100%)',
        '@media (min-width: 768px)': {
          padding: '80px 0'
        }
      }}>
        <div className="container" style={{
          maxWidth: '1200px',
          margin: '0 auto',
          padding: '0 15px',
          '@media (min-width: 576px)': {
            padding: '0 20px'
          }
        }}>
          <h2 style={{
            fontSize: '1.8rem',
            color: '#0f172a',
            marginBottom: '12px',
            textAlign: 'center',
            fontWeight: '800',
            lineHeight: '1.2',
            padding: '0 10px',
            '@media (min-width: 768px)': {
              fontSize: '2.2rem',
              marginBottom: '15px',
              padding: 0
            }
          }}>
            Your Complete Guide to U.S. Company Formation
          </h2>
          
          <p style={{
            fontSize: '1rem',
            color: '#4b5563',
            textAlign: 'center',
            maxWidth: '800px',
            margin: '0 auto 30px',
            lineHeight: '1.6',
            padding: '0 10px',
            '@media (min-width: 768px)': {
              fontSize: '1.1rem',
              margin: '0 auto 50px',
              padding: 0
            }
          }}>
            Everything you need to know about starting and registering your business in the United States
          </p>
          
          <div style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '30px',
            '@media (min-width: 992px)': {
              display: 'grid',
              gridTemplateColumns: '1fr 1fr',
              gap: '40px',
              alignItems: 'flex-start'
            },
            '@media (min-width: 1200px)': {
              gap: '50px'
            }
          }}>
            {/* Left Column - How to Start a Company */}
            <div style={{
              backgroundColor: 'white',
              borderRadius: '12px',
              padding: '25px',
              boxShadow: '0 10px 30px rgba(0, 0, 0, 0.05)',
              border: '1px solid rgba(0, 0, 0, 0.05)',
              width: '100%',
              boxSizing: 'border-box',
              '@media (min-width: 576px)': {
                padding: '30px'
              },
              '@media (min-width: 768px)': {
                padding: '35px'
              },
              '@media (min-width: 992px)': {
                padding: '40px',
                height: '100%',
                display: 'flex',
                flexDirection: 'column'
              }
            }}>
              <h3 style={{
                fontSize: '1.8rem',
                color: '#0f172a',
                marginBottom: '25px',
                fontWeight: '700',
                position: 'relative',
                paddingBottom: '15px',
                '@media (max-width: 768px)': {
                  fontSize: '1.5rem'
                }
              }}>
                <span style={{
                  position: 'absolute',
                  left: '0',
                  bottom: '0',
                  width: '50px',
                  height: '4px',
                  background: 'linear-gradient(90deg, #2D1FF4 0%, #6D63FF 100%)',
                  borderRadius: '4px'
                }}></span>
                How to Start a Company in the USA
              </h3>
              
              <ol style={{
                listStyleType: 'none',
                padding: 0,
                margin: 0,
                counterReset: 'step-counter',
                display: 'flex',
                flexDirection: 'column',
                gap: '12px'
              }}>
                {[
                  'Choose your business structure (LLC or C-Corp).',
                  'Select a U.S. state for registration.',
                  'Appoint a Registered Agent.',
                  'File Articles of Organization or Incorporation.',
                  'Apply for an EIN from the IRS.',
                  'Open a U.S. business bank account.',
                  'Stay compliant with state and federal tax filings.'
                ].map((step, index) => (
                  <li key={index} style={{
                    position: 'relative',
                    padding: '18px 20px 18px 70px',
                    backgroundColor: '#f8f9ff',
                    borderRadius: '10px',
                    fontSize: '1rem',
                    lineHeight: '1.6',
                    color: '#334155',
                    transition: 'all 0.3s ease',
                    borderLeft: '4px solid #2D1FF4',
                    ':hover': {
                      transform: 'translateX(5px)',
                      boxShadow: '0 5px 15px rgba(45, 31, 244, 0.1)'
                    },
                    '@media (max-width: 768px)': {
                      padding: '15px 15px 15px 60px',
                      fontSize: '0.95rem'
                    }
                  }}>
                    <span style={{
                      position: 'absolute',
                      left: '20px',
                      top: '50%',
                      transform: 'translateY(-50%)',
                      width: '32px',
                      height: '32px',
                      backgroundColor: '#2D1FF4',
                      color: 'white',
                      borderRadius: '50%',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      fontSize: '0.9rem',
                      fontWeight: 'bold',
                      boxShadow: '0 4px 10px rgba(45, 31, 244, 0.3)',
                      '@media (max-width: 768px)': {
                        width: '28px',
                        height: '28px',
                        fontSize: '0.8rem',
                        left: '15px'
                      }
                    }}>
                      {index + 1}
                    </span>
                    {step}
                  </li>
                ))}
              </ol>
            </div>
            
            {/* Right Column - Documents Required */}
            <div style={{
              backgroundColor: 'white',
              borderRadius: '12px',
              padding: '25px',
              boxShadow: '0 10px 30px rgba(0, 0, 0, 0.05)',
              border: '1px solid rgba(0, 0, 0, 0.05)',
              width: '100%',
              boxSizing: 'border-box',
              '@media (min-width: 576px)': {
                padding: '30px'
              },
              '@media (min-width: 768px)': {
                padding: '35px'
              },
              '@media (min-width: 992px)': {
                padding: '40px',
                height: '100%',
                display: 'flex',
                flexDirection: 'column'
              }
            }}>
              <h3 style={{
                fontSize: '1.8rem',
                color: '#0f172a',
                marginBottom: '25px',
                fontWeight: '700',
                position: 'relative',
                paddingBottom: '15px',
                '@media (max-width: 768px)': {
                  fontSize: '1.5rem'
                }
              }}>
                <span style={{
                  position: 'absolute',
                  left: '0',
                  bottom: '0',
                  width: '50px',
                  height: '4px',
                  background: 'linear-gradient(90deg, #2D1FF4 0%, #6D63FF 100%)',
                  borderRadius: '4px'
                }}></span>
                Documents Required
              </h3>
              
              <p style={{
                fontSize: '1.05rem',
                color: '#4b5563',
                lineHeight: '1.7',
                marginBottom: '25px',
                '@media (max-width: 768px)': {
                  fontSize: '1rem',
                  marginBottom: '20px'
                }
              }}>
                To register your company in the U.S., you'll typically need:
              </p>
              
              <ul style={{
                listStyleType: 'none',
                paddingLeft: '0',
                margin: '0 0 20px',
                display: 'flex',
                flexDirection: 'column',
                gap: '12px',
                flex: '1'
              }}>
                {[
                  'Passport or ID of each founder',
                  'U.S. Registered Agent details',
                  'Business name and address',
                  'Articles of Organization or Incorporation',
                  'EIN approval letter (IRS Form SS-4)'
                ].map((item, index) => (
                  <li key={index} style={{
                    padding: '18px 20px 18px 60px',
                    backgroundColor: '#f8f9ff',
                    borderRadius: '10px',
                    position: 'relative',
                    fontSize: '1rem',
                    color: '#334155',
                    transition: 'all 0.3s ease',
                    borderLeft: '4px solid #2D1FF4',
                    ':hover': {
                      transform: 'translateX(5px)',
                      boxShadow: '0 5px 15px rgba(45, 31, 244, 0.1)'
                    },
                    '@media (max-width: 768px)': {
                      padding: '15px 15px 15px 55px',
                      fontSize: '0.95rem'
                    }
                  }}>
                    <span style={{
                      position: 'absolute',
                      left: '20px',
                      top: '50%',
                      transform: 'translateY(-50%)',
                      color: '#2D1FF4',
                      fontWeight: 'bold',
                      fontSize: '1.5rem',
                      lineHeight: '1',
                      '@media (max-width: 768px)': {
                        left: '15px',
                        fontSize: '1.3rem'
                      }
                    }}>•</span>
                    {item}
                  </li>
                ))}
              </ul>
              
              <div style={{
                backgroundColor: '#f8f9ff',
                padding: '20px',
                borderRadius: '8px',
                marginTop: '20px',
                borderLeft: '4px solid #2D1FF4',
                flex: '1',
                display: 'flex',
                flexDirection: 'column'
              }}>
                <p style={{
                  margin: 0,
                  fontSize: '0.95rem',
                  color: '#334155',
                  lineHeight: '1.5',
                  paddingLeft: '10px',
                  position: 'relative',
                  breakInside: 'avoid',
                  '::marker': {
                    color: '#2D1FF4',
                    fontWeight: 'bold',
                    fontSize: '1.1em'
                  },
                  '@media (min-width: 576px)': {
                    fontSize: '1rem',
                    lineHeight: '1.6'
                  },
                  '@media (min-width: 768px)': {
                    fontSize: '1.05rem',
                    lineHeight: '1.7',
                    paddingRight: '10px'
                  }
                }}>
                  <span style={{
                    color: '#2D1FF4',
                    fontWeight: 'bold',
                    fontSize: '1.2rem',
                    lineHeight: '1.4'
                  }}>ℹ️</span>
                  <span>All documents can be securely uploaded through your BooksComply dashboard once you start your company formation process.</span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Why Choose BooksComply Section */}
      <section style={{
        padding: '80px 0',
        backgroundColor: '#ffffff',
        background: 'linear-gradient(135deg, #ffffff 0%, #f9faff 100%)',
        borderTop: '1px solid rgba(0, 0, 0, 0.05)'
      }}>
        <div className="container" style={{
          maxWidth: '1200px',
          margin: '0 auto',
          padding: '0 20px'
        }}>
          <h2 style={{
            fontSize: '2.2rem',
            color: '#0f172a',
            marginBottom: '15px',
            textAlign: 'center',
            fontWeight: '800',
            lineHeight: '1.2',
            '@media (max-width: 768px)': {
              fontSize: '1.8rem',
              marginBottom: '10px'
            }
          }}>
            Why Global Founders Choose BooksComply
          </h2>
          
          <p style={{
            fontSize: '1.1rem',
            color: '#4b5563',
            textAlign: 'center',
            maxWidth: '700px',
            margin: '0 auto 50px',
            lineHeight: '1.6',
            '@media (max-width: 768px)': {
              fontSize: '1rem',
              marginBottom: '30px'
            }
          }}>
            Trusted by entrepreneurs worldwide to establish and manage their U.S. business entities with confidence
          </p>
          
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
            gap: '25px',
            '@media (max-width: 768px)': {
              gridTemplateColumns: '1fr',
              maxWidth: '500px',
              margin: '0 auto'
            }
          }}>
            {[
              {
                icon: '🏢',
                title: 'End-to-End Formation',
                description: 'LLC, C-Corp, EIN, and tax setup handled for you.'
              },
              {
                icon: '🗺️',
                title: '50-State Coverage',
                description: 'We provide Registered Agents nationwide.'
              },
              {
                icon: '📊',
                title: 'Real-Time Dashboard',
                description: 'Track progress and compliance easily.'
              },
              {
                icon: '💲',
                title: 'Transparent Pricing',
                description: 'No hidden fees or extra charges.'
              },
              {
                icon: '👨‍💼',
                title: 'Expert Support',
                description: 'Dedicated account manager for every client.'
              }
            ].map((feature, index) => (
              <div key={index} style={{
                backgroundColor: 'white',
                borderRadius: '12px',
                padding: '30px',
                boxShadow: '0 5px 20px rgba(0, 0, 0, 0.03)',
                border: '1px solid rgba(0, 0, 0, 0.03)',
                transition: 'all 0.3s ease',
                ':hover': {
                  transform: 'translateY(-5px)',
                  boxShadow: '0 15px 30px rgba(0, 0, 0, 0.08)'
                },
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'flex-start',
                textAlign: 'left'
              }}>
                <div style={{
                  fontSize: '2.5rem',
                  marginBottom: '20px',
                  backgroundColor: '#f0f4ff',
                  width: '70px',
                  height: '70px',
                  borderRadius: '18px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  color: '#2D1FF4'
                }}>
                  {feature.icon}
                </div>
                <p style={{
                  fontSize: '0.85rem',
                  color: '#64748b',
                  marginTop: 'auto',
                  marginBottom: '0',
                  paddingTop: '15px',
                  fontStyle: 'italic',
                  lineHeight: '1.6',
                  borderTop: '1px solid rgba(0, 0, 0, 0.05)',
                  '@media (min-width: 576px)': {
                    fontSize: '0.9rem'
                  }
                }}>
                  {feature.title}
                </p>
                <p style={{
                  margin: 0,
                  fontSize: '1rem',
                  color: '#4b5563',
                  lineHeight: '1.6',
                  opacity: '0.9'
                }}>
                  {feature.description}
                </p>
              </div>
            ))}
          </div>
          
        </div>
      </section>
      
      <FAQSection />
      {showContactForm && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          zIndex: 1050,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          backdropFilter: 'blur(3px)'
        }}>
          <div style={{
            position: 'relative',
            width: '100%',
            maxWidth: '600px',
            maxHeight: '90vh',
            overflowY: 'auto',
            backgroundColor: 'white',
            borderRadius: '12px',
            padding: '30px',
            boxShadow: '0 10px 30px rgba(0, 0, 0, 0.2)'
          }}>
            <button 
              onClick={() => setShowContactForm(false)}
              style={{
                position: 'absolute',
                top: '15px',
                right: '15px',
                background: 'transparent',
                border: 'none',
                fontSize: '24px',
                cursor: 'pointer',
                color: '#666',
                padding: '5px 10px',
                borderRadius: '4px',
                transition: 'all 0.2s',
                zIndex: 10
              }}
              onMouseOver={(e) => e.currentTarget.style.color = '#2D1FF4'}
              onMouseOut={(e) => e.currentTarget.style.color = '#666'}
              aria-label="Close contact form"
            >
              &times;
            </button>
            <ContactForm onClose={() => setShowContactForm(false)} />
          </div>
        </div>
      )}
    </section>
  );
};

export default App;
